import { ProgramNames, PROVIDER_TYPES } from '../../../models'
import { PROGRAM_TAXONOMY, ProgramCustomerPropertyId } from '../../common/constants/customerProgram'
import { TREATMENT_OPTIONS } from '../../common/constants/treatmentOptions'
import { ConsentText, ProgramDisplayLabels } from '../messages'
import { ProgramConfig } from '../types'

export const CLINICAL_LEAVE_EVALUATION_PROGRAM = {
  programName: ProgramNames.ClinicalLeaveEvaluation,
  blendedCareProgramId: '6f146c5b-ac3b-42e5-b2a2-aacb3035e6d8',
  customerPropertyId: ProgramCustomerPropertyId.clinicalLeaveEvaluation,

  displayLabels: {
    default: ProgramDisplayLabels.clinicalLeaveEvaluation,
    short: 'CLE',
    clientProfile: 'Short Term Disability Eval',
    sessionSummary: 'short term disability evaluation',
  },

  associatedProviderTypes: [PROVIDER_TYPES.LYRACLINICALLEAVEEVALUATOR.lyraType],
  associatedProviderModalities: ['clinicalLeaveEvaluation'],

  canRescheduleAppointment: false,
  selfPayEligible: false,

  treatmentOptionProperties: {
    associatedTriageTreatmentOptions: [TREATMENT_OPTIONS.CLINICAL_LEAVE_EVALUATION],
    programTaxonomyTreatmentOptions: [
      {
        clientele: PROGRAM_TAXONOMY.clientele.individual,
        treatment: PROGRAM_TAXONOMY.treatment.assessment,
        partner: PROGRAM_TAXONOMY.partner.blendedCare,
        offering: PROGRAM_TAXONOMY.offering.clinicalLeave,
      },
    ],
    isFullTreatmentOption: false,
  },

  consents: [
    {
      consentText: ConsentText.therapyConsent,
      consentUrl: 'https://www.lyrahealth.com/lt-agreement',
      showConsentIf: () => true,
    },
  ],

  questionIdentifiers: {
    SI_QUESTION: 'phq9_9',
    SI_PLAN_QUESTION: 'phq9_9_1',
    SI_INTENT_QUESTION: 'phq9_9_2',
  },

  noteContentMetadataName: {
    INITIAL_NOTE: 'cleInitialNote',
    SESSION_NOTE: 'cleSessionNote',
    GENERAL_NOTE: 'cleGeneralNote',
    REFERRAL_NOTE: 'baseReferralNote',
  },
} satisfies ProgramConfig
